import { useCallback, useState } from 'react';
import { SectionRenderer } from '@/components/sections/SectionRenderer';
import { useSeo } from '@/lib/useSeo';
import { PAGE_SEO } from '@/data/pageSeoConfig';
import { HOME_SECTIONS } from '@/data/homeSections.config';
import { usePrerenderReady } from '@/hooks/usePrerenderReady';
import { buildHomepageBusinessGraph } from '@/lib/globalFloristSchema';
import { isPrerenderMode } from '@/lib/isPrerenderMode';
import { serializeCmsJson } from '@workspace/url-source/cms';

export default function Home() {
  // Hero jest sekcją eager/LCP, a pozostałe sekcje są montowane leniwie
  // (viewport-gated, patrz DeferredSection). usePrerenderReady musi poczekać,
  // aż WSZYSTKIE zdążą
  // się zamontować (Playwright w trybie prerenderu je wymusza od razu, ale
  // wciąż asynchronicznie — patrz isPrerenderMode), inaczej snapshot
  // zawierałby tylko puste placeholdery zamiast treści SEO.
  const [mountedCount, setMountedCount] = useState(0);
  const enabledCount = HOME_SECTIONS.filter(s => s.enabled).length;
  const handleSectionMounted = useCallback(() => setMountedCount(c => c + 1), []);

  usePrerenderReady(mountedCount >= enabledCount);
  useSeo(PAGE_SEO.home);

  return (
    <div className="min-h-[100dvh] bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: serializeCmsJson(buildHomepageBusinessGraph()) }}
      />
      <main>
        <SectionRenderer
          sections={HOME_SECTIONS}
          onSectionMounted={isPrerenderMode ? handleSectionMounted : undefined}
        />
      </main>
    </div>
  );
}
